import { NgClass } from '@angular/common';
import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SparrowIconEnum } from '../../../core/icons-registry';

@Component({
  selector: 'sparrow-snackbar',
  templateUrl: './sparrow-snackbar.component.html',
  styleUrls: ['./sparrow-snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, MatIconModule],
})
export class SparrowSnackbarComponent {
  title: string;
  icon: string;
  extraClass: 'info' | 'success' | 'alert';
  textColor: 'green' | 'blue';

  readonly iconMap: Record<string, SparrowIconEnum> = {
    success: SparrowIconEnum.CheckCircle,
    info: SparrowIconEnum.InfoCircle,
    alert: SparrowIconEnum.WarningCircle,
  };

  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      title: string | undefined;
      icon: string | undefined;
      extraClass: 'info' | 'success' | 'alert' | undefined;
      textColor: 'green' | 'blue' | undefined;
    },
  ) {
    this.title = this.data.title;
    this.icon = this.data.icon;
    this.extraClass = this.data.extraClass;
    this.textColor = this.data.textColor;
  }

  get currentIcon(): SparrowIconEnum | null {
    return this.iconMap[this.extraClass] || null;
  }
}
